import React from "react";
import * as CHQ from "chq";

import { Trans } from "app/utils";
import NotificationBody from "./NotificationBody";

type ProcessingNotificationProps = {
  notification: CHQ.NotificationProcessingVideoStoryQuestion;
  tabIndex?: number;
};

const ProcessingVideoStoryQuestionNotification: React.FC<ProcessingNotificationProps> = ({
  notification: { entity }
}) => (
  <NotificationBody actor={entity}>
    <Trans>
      The story trend page is being built, we will let you know as soon as it is ready
    </Trans>
    <br />
  </NotificationBody>
);

export default ProcessingVideoStoryQuestionNotification;
